function SuspenseContent() {
  return (
    <></>
  );
}

export default SuspenseContent;
